import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs';
import {find} from 'lodash';
import {Country} from './country';

@Injectable()
export class CountryService {

    private countries$: Observable<Country[]>;

    constructor(private http: Http) {}

    /** Return all countries. */
    public getCountries(): Observable<Country[]> {
        if (!this.countries$) {
            this.countries$ = this.http
                .get('/api/client/dictionary/countries')
                .map(response => response.json())
                .map(response => response.countries)
                .publishReplay(1)
                .refCount();
        }

        return this.countries$;
    }

    /** Return first country by filter */
    public findFirstCountryBy(query: Country | any): Observable<Country> {
        return this.getCountries()
            .map(countries => find(countries, query));
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/dictionary/country/api/country.service.ts